import { render, staticRenderFns } from "./CommissionTable.vue?vue&type=template&id=5fbb9483&scoped=true"
import script from "./CommissionTable.vue?vue&type=script&lang=ts"
export * from "./CommissionTable.vue?vue&type=script&lang=ts"
import style0 from "./CommissionTable.vue?vue&type=style&index=0&id=5fbb9483&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fbb9483",
  null
  
)

export default component.exports